import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  getAllMessages,
  postMessage,
  generatePreSignedUrlMsg,
  getPreviewLink,
} from "../services/httpCalls";
import { useEffect, useState, useRef } from "react";
import { Button, Grid, TextareaAutosize, IconButton } from "@mui/material";
import { DateConvert } from "../utils/dateConverter";
import useNotify from "../utils/useNotify";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";

const style = {
  position: "absolute",
  top: "50%",
  left: "53%",
  transform: "translate(-50%, -50%)",
  width: "65vw",
  height: "85vh",
  borderRadius: "10px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  outline: "none",
};

export default function ChatsModal(props) {
  const [allChat, setAllChat] = useState();
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState();
  const [selectedTag, setSelectedTag] = useState();
  const [files, setFiles] = useState([]);
  const bottomRef = useRef(null);
  const notify = useNotify();
  let activeChatType = props.activeChat === "ca" ? "CA_FIRM" : "BANK";

  useEffect(() => {
    if (props.showChats || refresh) {
      const allMessages = async () => {
        await getAllMessages(props.traxId, props.firmId)
          .then((res) => {
            setAllChat(res);
            setTimeout(() => {
              bottomRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 10);
            setRefresh(false);
          })
          .catch(() => {});
      };
      allMessages();
    }
  }, [props.showChats, refresh]);

  const sendMessage = async () => {
    const userInfo = JSON.parse(Cookies.get("userInfo"));
    if (message && !files.length) {
      if (selectedTag) {
        let data_ = {
          messageTypeList: ["TEXT", "TEXT"],
          messageTag: selectedTag?.toUpperCase(),
          companyType: `${activeChatType}`,
          messageText: message,
          transactionId: props.traxId,
          userType: "OPS_MEMBER",
          messageDocumentDtoList: [],
        };
        setTimeout(async () => {
          await postMessage(data_, props.firmId, userInfo.id)
            .then((res) => {
              setRefresh(true);
              setMessage("");
              setSelectedTag("");
              setFiles([]);
              notify.success("Message sent succesfully");
            })
            .catch((err) => {
              notify.error("Message Not sent");
            });
        }, 1000);
      } else {
        notify.error("Select atleast one tag from below");
      }
    } else if (message && files.length) {
      if (selectedTag) {
        let data_ = {
          messageTypeList: ["DOCUMENT", "TEXT"],
          messageTag: selectedTag?.toUpperCase(),
          companyType: `${activeChatType}`,
          messageText: message,
          transactionId: props.traxId,
          userType: "OPS_MEMBER",
          messageDocumentDtoList: [],
        };
        await Object.keys(files)?.forEach((item, i) => {
          filesSelected(files[item]).then((msgDto) => {
            data_.messageDocumentDtoList.push(msgDto);
            if (data_.messageDocumentDtoList.length === files.length) {
              postMessage(data_, props.firmId, userInfo.id)
                .then((res) => {
                  setRefresh(true);
                  setMessage("");
                  setSelectedTag("");
                  notify.success("Message sent succesfully");
                  setFiles([]);
                })
                .catch((err) => {
                  notify.success("Message Not sent");
                });
            }
          });
        });
      } else {
        notify.error("Select atleast one tag from below");
      }
    } else if (!message && files.length && selectedTag) {
      let data_ = {
        messageTypeList: ["DOCUMENT", "DOCUMENT"],
        messageTag: selectedTag?.toUpperCase(),
        companyType: `${activeChatType}`,
        messageText: null,
        transactionId: props.traxId,
        userType: "OPS_MEMBER",
        messageDocumentDtoList: [],
      };
      await Object.keys(files)?.forEach((item, i) => {
        filesSelected(files[item]).then((msgDto) => {
          data_.messageDocumentDtoList.push(msgDto);
          if (data_.messageDocumentDtoList.length === files.length) {
            postMessage(data_, props.firmId, userInfo.id)
              .then((res) => {
                setRefresh(true);
                setMessage("");
                setSelectedTag("");
                setFiles([]);
                notify.success("Message sent succesfully");
              })
              .catch((err) => {
                notify.error("Message Not sent");
              });
          }
        });
      });
    } else {
      notify.error("Select atleast one tag from below");
    }
  };
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
  };

  const filesSelected = async (file) => {
    let msgDto;
    if (file) {
      await generatePreSignedUrlMsg(file.name).then(async (res) => {
        const url = res?.preSignedUrl;
        await uploadFileToS3(res?.preSignedUrl, file).then(async (res) => {
          let newPresignedUrl = url.split("?")[0];
          newPresignedUrl = decodeURI(newPresignedUrl);
          msgDto = {
            documentS3Url: newPresignedUrl,
            documentName: file.name,
          };
        });
      });
    }
    return msgDto;
  };
  const previewFile = (id) => {
    getPreviewLink(id).then((res) => {
      if (res.preSignedUrl) {
        window.open(res.preSignedUrl, "_blank", "noopener,noreferrer");
      }
    });
  };
  return (
    <Modal open={props.showChats} onClose={() => props.setShowChats(false)}>
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #f2f2f2",
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ color: "#3146d0", letterSpacing: ".6px" }}
          >
            Chats with {props.activeChat === "ca" ? "CA" : "Bank"}
          </Typography>
          <IconButton onClick={() => props.setShowChats(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className="chat_wrap">
          {allChat ? (
            allChat?.map((item, i) => {
              let ref,
                file_flag = false;
              if (allChat.length === i + 1) {
                ref = bottomRef;
              }
              if (item.messageDocumentDtoList) {
                file_flag = true;
              }
              return (
                <Box
                  className={`chat_ ${item.userType.toLowerCase()}_type`}
                  key={i}
                  ref={ref}
                >
                  <Typography>{item.messageText}</Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      className={`tag_chat ${item.messageTag.toLowerCase()}`}
                    >
                      {item.messageTag}
                    </Typography>
                    <Typography className="dateTime">
                      {DateConvert(parseInt(item.creationTime))}
                    </Typography>
                  </Box>
                  {file_flag &&
                    item.messageDocumentDtoList.map((file, i) => {
                      return (
                        <Box key={i} onClick={(e) => previewFile(file.id)}>
                          <Typography
                            sx={{
                              fontSize: "14px !important",
                              color: "blue !important",
                              marginTop: ".5rem",
                              marginBottom: "0!important",
                              cursor: "pointer",
                            }}
                          >
                            {file.documentName}
                          </Typography>
                        </Box>
                      );
                    })}
                </Box>
              );
            })
          ) : (
            <Typography>
              {" "}
              {props.firmId
                ? "No Messages"
                : props.activeChat === "ca"
                ? "CA Not Selected"
                : "Bank details not added"}
            </Typography>
          )}
        </Box>
        <Box className="chat_input">
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextareaAutosize
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type here..."
                value={message}
              />
              <Box className="tags_wrap">
                <Typography
                  className={`tag_chat ${
                    selectedTag === "comment" ? "selected" : "disabled"
                  }`}
                  onClick={() => setSelectedTag("comment")}
                >
                  comment
                </Typography>
                <Typography
                  className={`tag_chat partially_resolved ${
                    selectedTag === "partially_resolved"
                      ? "selected"
                      : "disabled"
                  }`}
                  onClick={() => setSelectedTag("partially_resolved")}
                >
                  partially resolved
                </Typography>
                <Typography
                  className={`tag_chat resolved ${
                    selectedTag === "resolved" ? "selected" : "disabled"
                  }`}
                  onClick={() => setSelectedTag("resolved")}
                >
                  resolved
                </Typography>
                <Typography
                  className={`tag_chat notification ${
                    selectedTag === "notification" ? "selected" : "disabled"
                  }`}
                  onClick={() => setSelectedTag("notification")}
                >
                  notify
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                onClick={sendMessage}
                sx={{ backgroundColor: "#3146d0" }}
                disabled={props.firmId ? false : true}
              >
                Send
              </Button>
              <Button
                variant="outlined"
                component="label"
                disabled={props.firmId ? false : true}
                sx={{
                  marginTop: ".5rem",
                  border: "1px solid #3146d0",
                  color: "#3146d0",
                  width: "100%",
                }}
              >
                Attach {files.length > 0 && files.length}{" "}
                <input
                  type="file"
                  multiple={true}
                  // onChange={(e) => filesSelected(e.target.files)}
                  onChange={(e) => setFiles(e.target.files)}
                  hidden
                />
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
}
